// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"folder-off"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 6H22V19H6M2 16L2.00195 14.5L2.00097 3.5L9.00096 3.5L11.001 6L13.001 6M2 16L2.00195 17L2.00095 17.001L2 16Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20 4L3 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FolderOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-off',
    ref,
    icon: element,
  },
));

FolderOffIcon.displayName = 'FolderOffIcon';

export default FolderOffIcon;
